import { CheckBoxFilterType } from './types'
import { ParamsUpdater } from '../List/hooks'
import React, { useCallback } from 'react'

type CheckBoxFilterProps<T> = {
  readonly filter: CheckBoxFilterType<T>
  readonly value: ReadonlyArray<string | number>
  readonly updateParams: ParamsUpdater<T>
}
export const CheckBoxFilter = <T,>({
  filter,
  value,
  updateParams,
}: CheckBoxFilterProps<T>): JSX.Element => {
  const toggleAll = useCallback((): void => {
    updateParams(
      filter.fieldName,
      value.length === filter.options.length
        ? []
        : filter.options.map((f) => f.value)
    )
  }, [value])

  const onCheck = useCallback(
    (ev: React.ChangeEvent<HTMLInputElement>) => {
      const optionValue = ev.target.value
      const newValue = value.includes(optionValue)
        ? value.filter((v) => v !== optionValue)
        : [...value, optionValue]
      updateParams(filter.fieldName, newValue)
    },
    [value]
  )

  return (
    <>
      <div>
        <label>
          <input
            name={filter.fieldName.toString()}
            type='checkbox'
            value={''}
            onChange={toggleAll}
            checked={value.length === filter.options.length}
            title={'All'}
          />
          All
        </label>
      </div>
      {filter.options.map((o) => (
        <div key={o.value}>
          <label>
            <input
              name={filter.fieldName.toString()}
              type='checkbox'
              value={o.value}
              onChange={onCheck}
              checked={value.includes(o.value)}
              title={o.name}
            />
            {o.name}
          </label>
        </div>
      ))}
    </>
  )
}
